<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav" :class="{ 'hidden' : checkRegist }">
        <SidebarProfile />
        <!-- OKR -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/okr'" disabled> -->
        <!-- <li class="nav-item nav-dropdown" disabled :class="{ 'open' : okr }"> -->
          <li v-if ="!isLiteMode" class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'okr' || this.checkActiveLink == 'okr' }">
            <div class="nav-link nav-dropdown-toggle" @click="handleClick('okr')">
              <img :src="'static/img/assets/nav_okr_off.png'">
              {{$t('sidebar.okr.title')}}
            </div>
            <ul class="nav-dropdown-items">
              <li @click="hideMobile" class="nav-item">
                <div>
                  <!-- <router-link @click="onClickSidebar($event)" :to="'/okr/list'" class="nav-link"> -->
                  <span @click="onClickSidebar($event, 'OkrList')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OkrList' }">
                    {{$t('sidebar.okr.list')}}
                  </span>
                <!-- </router-link> -->
                </div>
              </li>
              <li @click="hideMobile" class="nav-item">
                <div>
                  <!-- <router-link @click="onClickSidebar($event)" :to="'/okr/objective-regist'" class="nav-link"> -->
                  <span @click="onClickSidebar($event, 'ObjectiveRegist')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ObjectiveRegist' }">
                    {{$t('sidebar.okr.regist')}}
                  </span>
                  <!-- </router-link> -->
                </div>
              </li>
              <li @click="hideMobile" class="nav-item">
                <div>
                  <!-- <router-link @click="onClickSidebar($event)" :to="'/okr/complete'" class="nav-link"> -->
                  <span @click="onClickSidebar($event, 'OkrComplete')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OkrComplete' }">
                    {{$t('sidebar.okr.complete')}}
                  </span>
                  <!-- </router-link> -->
                </div>
              </li>
            </ul>
          </li>
        <!-- </router-link> -->
        <!-- 1on1 -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/one'" disabled> -->
        <li class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'one' || this.checkActiveLink == 'one' }">
          <div class="nav-link nav-dropdown-toggle" @click="handleClick('one')">
            <img :src="'static/img/assets/nav_1on1_off.png'">
            {{$t('sidebar.one.title')}}
          </div>
          <ul class="nav-dropdown-items">
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/one/list'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'OneList')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OneList' }">
                  {{$t('sidebar.one.list')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/one/regist'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'OneRegist')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OneRegist' }">
                  {{$t('sidebar.one.regist')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/one/request'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'OneRequest')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OneRequest' }">
                  {{$t('sidebar.one.request')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/one/request-sent'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'OneRequestSent')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OneRequestSent' }">
                  {{$t('sidebar.one.history')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <!-- <li @click="hideMobile" class="nav-item">
              <div> -->
                <!-- <router-link @click="onClickSidebar($event)" :to="'/one/request-sent'" class="nav-link"> -->
                <!-- <span @click="onClickSidebar($event, 'OneRequestRece')" class="nav-link">
                  {{$t('sidebar.one.reception')}}
                </span> -->
                <!-- </router-link> -->
              <!-- </div> -->
            <!-- </li> -->
          </ul>
        </li>
        <!-- </router-link> -->
        <!-- FBRequest -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/fb'" disabled> -->
        <li class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'fb' || this.checkActiveLink == 'fb' }">
          <div class="nav-link nav-dropdown-toggle" @click="handleClick('fb')">
            <img :src="'static/img/assets/nav_rtfb_off.png'">
            {{$t('sidebar.rtfbs.title')}}
          </div>
          <ul class="nav-dropdown-items">
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/fb/list'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'FbRequestList')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'FbRequestList' }">
                  {{$t('sidebar.rtfbs.list')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/fb/regist'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'FbRegist')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'FbRegist' }">
                  {{$t('sidebar.rtfbs.regist')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
          </ul>
        </li>
        <!-- </router-link> -->
        <!-- People -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/people'" disabled> -->
        <li class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'people' || this.checkActiveLink == 'people' }">
          <div class="nav-link nav-dropdown-toggle" @click="handleClick('people')">
            <img :src="'static/img/assets/nav_people_off.png'">
            {{$t('sidebar.people.title')}}
          </div>
          <ul class="nav-dropdown-items">
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/people/search'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'UserSearch')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'UserSearch' }">
                  {{$t('sidebar.people.search')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/people/group-list'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'GroupList')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'GroupList' }">
                  {{$t('sidebar.people.list')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/people/group-regist'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'GroupRegist')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'GroupRegist' }">
                  {{$t('sidebar.people.regist')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/people/search'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'OrganizationList')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OrganizationList' }">
                  {{$t('organizationListStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
          </ul>
        </li>
        <!-- </router-link> -->
        <!-- Notice -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/notice'" disabled> -->
        <li class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'notice' || this.checkActiveLink == 'notice' }">
          <div class="nav-link nav-dropdown-toggle" @click="handleClick('notice')">
            <img :src="'static/img/assets/nav_notice_off.png'">
            {{$t('sidebar.notice.title')}}
          </div>
          <ul class="nav-dropdown-items">
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/notice/list'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'NoticeList')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'NoticeList' }">
                  {{$t('sidebar.notice.list')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/notice/setting'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'NoticeSetting')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'NoticeSetting' }">
                  {{$t('sidebar.notice.setting')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/one/request-sent'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'OneRequestRece')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OneRequestRece' }">
                  {{$t('sidebar.one.reception')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
          </ul>
        </li>
        <!-- </router-link> -->
        <!-- Report -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/report'" disabled> -->
          <li v-if="!isLiteMode" class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'report' || this.checkActiveLink == 'report' }">
            <div class="nav-link nav-dropdown-toggle" @click="handleClick('report')">
              <img :src="'static/img/assets/nav_report_off_2.png'">
              Report
            </div>
            <ul class="nav-dropdown-items">
              <li @click="hideMobile" class="nav-item">
                <div>
                  <!-- <router-link @click="onClickSidebar($event)" :to="'/report/report-relations'" class="nav-link"> -->
                  <span @click="onClickSidebar($event, 'ReportRelations')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ReportRelations' }">
                    {{$t('OKRReportStr')}}
                  </span>
                  <!-- </router-link> -->
                </div>
              </li>
              <li @click="hideMobile" class="nav-item">
                <div>
                  <!-- <router-link @click="onClickSidebar($event)" :to="'/report/report-1on1s'" class="nav-link"> -->
                  <span @click="onClickSidebar($event, 'Report1on1s')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'Report1on1s' }">
                    {{$t('1on1ReportStr')}}
                  </span>
                  <!-- </router-link> -->
                </div>
              </li>
            </ul>
          </li>
        <!-- </router-link> -->
        <!-- Other -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/notice'" disabled> -->
        <li class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'config' || this.checkActiveLink == 'config' }">
          <div class="nav-link nav-dropdown-toggle" @click="handleClick('config')">
            <img :src="'static/img/assets/nav_tool_off.png'">
            {{$t('sidebar.other.title')}}
          </div>
          <ul class="nav-dropdown-items">
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/notice/list'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'Help')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'Help' }">
                  {{$t('sidebar.other.help')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li v-if="!isLicenseAgreement " @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/notice/setting'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'Terms')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'Terms' }">
                  {{ isLicenseAgreement ?  $t('licenseAgreementTitle') : $t('sidebar.other.terms') }}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li v-else-if="isLicenseAgreement " @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/notice/setting'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'Terms')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'Terms' }">
                  {{$t('licenseAgreementTitle')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item" v-if="authType !== 'adfs'">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/notice/setting'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ResetPassword')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ResetPassword' }">
                  {{$t('sidebar.other.reset')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
             <li @click="hideMobile" class="nav-item">
              <div>
                <span v-b-modal.aboutModal @click="onClickSidebar($event, 'About')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'About' }">
                  <!-- {{$t('sidebar.other.reset')}} -->
                  About
                </span>
              </div>
            </li>
          </ul>
        </li>
        <!-- </router-link> -->
        <!-- Management -->
        <!-- <router-link tag="li" class="nav-item nav-dropdown" :to="'/report'" disabled> -->
        <li class="nav-item nav-dropdown" disabled :class="{ 'open' : this.checkOpenNav == 'manage' || this.checkActiveLink == 'manage' }" v-if="this.isManager && getIsAllowedIPAddressForManagement">
          <div class="nav-link nav-dropdown-toggle" @click="handleClick('manage')">
            <img :src="'static/img/assets/nav_manage_off_2.png'">
            Management
          </div>
          <ul class="nav-dropdown-items">
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/okr/complete'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'OkrNetwork')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'OkrNetwork' }">
                  {{$t('okrNetworkStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/okr/complete'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ManageOkrSelect')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ManageOkrSelect' }">
                  {{$t('okrTreeStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <span @click="onClickSidebar($event, 'ProxyOkr')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ProxyOkr' }">
                  OKR代理入力
                </span>
              </div>
            </li>
            <li @click="hideMobile" class="nav-item">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/report/report-1on1s'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ReportActivity')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ReportActivity' }">
                  {{$t('activityReportStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item" v-if="this.isAdmin">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/manage/users'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ManageUsers')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ManageUsers' }">
                  {{$t('userManageStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item" v-if="this.isAdmin">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/report/report-1on1s'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ManageGroups')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ManageGroups' }">
                  {{$t('ManageGroupStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item" v-if="this.isAdmin">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/report/report-1on1s'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ManageOrganization')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ManageOrganization' }">
                  {{$t('OrganizationStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item" v-if="this.isAdmin">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/manage/users'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ManageEmails')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ManageEmails' }">
                  {{$t('availableUserRegistStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
            <li @click="hideMobile" class="nav-item" v-if="this.isAdmin">
              <div>
                <!-- <router-link @click="onClickSidebar($event)" :to="'/manage/users'" class="nav-link"> -->
                <span @click="onClickSidebar($event, 'ManageUserSearch')" class="nav-link" :class="{ 'active' : this.checkActiveNav == 'ManageUserSearch' }">
                  {{$t('userInputDataManageStr')}}
                </span>
                <!-- </router-link> -->
              </div>
            </li>
          </ul>
        </li>
        <!-- </router-link> -->
      </ul>
      <slot></slot>
    </nav>
    <b-modal id="aboutModal" :ok-title="'OK'"  :ok-only="true" ref="aboutModal" size="sm" centered>
      <!-- <div class=""> -->
        <img :src="'static/img/icon.png'" alt="1on1navi">
        <div>1on1navi<br>for<br>{{checkCompanyName}}<br>{{checkAppVersion}}</div>
      <!-- </div> -->
    </b-modal>
  </div>
</template>
<script>
import SidebarProfile from './SidebarProfile'
import { mapGetters, mapActions } from 'vuex'
import { willysm, settings, about, liteMode, licenseAgreement } from '@/main'

export default {
  name: 'sidebar',
  components: {
    SidebarProfile
  },
  data: function () {
    return {
      // isManager: false,
      // okr: false,
      authType: settings.authType,
      currentTimestamp: '',
      regist: false,
      activeNav: '',
      activeLink: '',
      openNav: '',
      modalShow: false,
      willysmEnabled: willysm.enabled,
      licenseAgreement: licenseAgreement
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement',
      'getEdittingProfileFlag'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsAdmin',
      'getMetaIsManager'
    ]),
    isAdmin: function () {
      return this.getMetaIsAdmin
    },
    isLicenseAgreement: function () {
      return licenseAgreement
    },
    isManager: function () {
      return this.getMetaIsManager
    },
    isLiteMode: function () {
      return liteMode
    },
    checkCompanyName () {
      if (about && about.companyName) return about.companyName
      else return ''
    },
    checkAppVersion () {
      if (about && about.appVersion) return about.appVersion
      else return ''
    },
    checkRegist: {
      get () {
        return this.regist
      },
      set (value) {
        this.regist = value
      }
    },
    checkActiveNav: {
      get () {
        return this.activeNav
      },
      set (value) {
        this.activeNav = value
      }
    },
    checkActiveLink: {
      get () {
        return this.activeLink
      },
      set (value) {
        this.activeLink = value
      }
    },
    checkOpenNav: {
      get () {
        return this.openNav
      },
      set (value) {
        this.openNav = value
      }
    }
  },
  created: function () {
  },
  mounted: function () {
    console.log('route in sidebar in mounted', this.$route.name)
    if (this.$route.name === 'ProfileRegist') {
      this.checkRegist = true
    } else {
      this.checkRegist = false
    }
    const getIsAllowedAddressForManagement = this.$firebase.functions().httpsCallable('getIsAllowedAddressForManagement')
    getIsAllowedAddressForManagement().then((result) => {
      console.log('getIsAllowedAddressForManagement', result)
      this.setIsAllowedIPAddressForManagement(result.data.isAllowed)
    })
    const getIsAllowedAddress = this.$firebase.functions().httpsCallable('getIsAllowedAddress')
    getIsAllowedAddress().then((result) => {
      console.log('getIsAllowedAddress', result)
      this.setIsAllowedIPAddress(result.data.isAllowed)
    })
  },
  methods: {
    ...mapActions({
      setCurrentTimestamp: 'SET_CURRENT_TIMESTAMP'
    }),
    ...mapActions('repository/', {
      setIsAllowedIPAddressForManagement: 'setIsAllowedIPAddressForManagement',
      setIsAllowedIPAddress: 'setIsAllowedIPAddress'
    }),
    handleClick (openNav) {
      // e.preventDefault()
      // e.target.parentElement.classList.toggle('open')
      if (this.checkOpenNav === openNav) {
        this.checkOpenNav = ''
      } else if (this.checkActiveLink === openNav) {
        this.checkActiveLink = ''
      } else {
        this.checkOpenNav = openNav
      }
    },
    changeNavActive (componentName, activeNavParent) {
      this.checkActiveNav = componentName
      this.checkActiveLink = activeNavParent
    },
    navClick (componentName) {
      // e.preventDefault()
      // // e.target.classList.toggle('open')
      // console.log('e.target.classLis::t', e.target.classList)
    },
    hideMobile () {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show')
      }
    },
    onClickSidebar (evt, target) {
      console.log('getIsAllowedIPAddressForManagement', this.getIsAllowedIPAddressForManagement)
      console.log('target', target)
      console.log('evt', evt)
      console.log('e.target.classLis::t', evt.target.classList)
      // evt.target.classList.add('active')
      // const setTimestamp = this.setCurrentTimestamp()
      console.log('$route.name', this.$route.name)
      let isShowSWAL = (
        this.$route.name.indexOf('Edit') > 0 ||
        this.$route.name.indexOf('SettingDetail') > 0 ||
        this.$route.name.indexOf('Regist') > 0 ||
        (this.getEdittingProfileFlag && this.$route.name.indexOf('Profile') > -1) ||
        (this.$route.name.indexOf('OneRequest') > -1 && this.$route.name.indexOf('Rece') < 0 && this.$route.name.indexOf('Sent') < 0)
      )
      if (target === 'About') {
        this.modalShow = true
      } else if (isShowSWAL) {
        // const setTimestamp = this.setCurrentTimestamp()
        const $t = this.$t
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          // text: $t('doDeleteStr'),
          text: $t('confirmInputDeleteStr'),
          showCancelButton: true,
          cancelButtonColor: '#f64846',
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 3000
        }).then((result) => {
          if (result.value) {
            // okが押下されたら
            // e.target.parentElement.classList.toggle('active')
            // this.setTimestamp()
            // this.currentTimestamp = new Date().getTime() / 1000
            // this.currentTimestamp = Math.round((new Date()).getTime() / 1000)
            // this.setCurrentTimestamp(this.currentTimestamp)
            this.$router.push({ name: target })
          } else {
            // cancelが押下されたら
            console.log('false')
          }
        })
      } else {
        // const setTimestamp = this.setCurrentTimestamp()
        // this.setTimestamp()
        // this.currentTimestamp = new Date().getTime() / 1000
        // this.currentTimestamp = Math.round((new Date()).getTime() / 1000)
        // this.setCurrentTimestamp(this.currentTimestamp)
        this.$router.push({ name: target })
      }
      // this.$router.push({ name: target })
    },
    onChangeHidden: function (profileRegist) {
      if (profileRegist) this.checkRegist = true
      else this.checkRegist = false
    }
  }
}
</script>

<style scoped lang="scss">
  .hidden {
    visibility: hidden;
  }
  .sidebar-nav{
   font-weight: 600;
  }
  .nav-link {
    cursor:pointer;
  }
  .nav-link img{
    width: 1.5rem;
    margin-right: 1rem;
  }
  .nav-item div a.nav-link, .nav-item div span.nav-link{
    text-indent: 2.7rem;
  }
  .sidebar .nav-dropdown.open{
    background: rgba(0, 0, 50, 0.0);
  }
  .sidebar .nav-dropdown-toggle::before{
    color: #fff;
  }
  span.nav-link{
    transition: 0.2s ease;
    // &.active:before{
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   display: inline-block;
    //   width: 2.2rem;
    //   height: 4.2rem;
    //   background-color: #fbc64e;
    // }
    &:active {
      background-color: #fbc64e !important;
    }
  }
  .modal-dialog {
      margin: 15rem auto;
      .modal-content {
        .modal-header h5.modal-title {
          color: #151b1e;
        }
        .modal-body {
          div {
            color: #151b1e;
            text-align: center;
            margin-bottom: 1.5rem;
          }
          img {
            display: block;
            width: 100%;
            max-width: 100px;
            min-width: 80px;
            margin: 1rem auto 1.5rem;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue